export function useToast() {
  const toasts = useState("toasts", () => []);
  const remove = (id) => {
    const i = toasts.value.findIndex((x) => x.id === id);
    if (i >= 0) toasts.value.splice(i, 1);
  };
  const show = (message, opts = {}) => {
    const id = Date.now().toString(36) + Math.random().toString(16).slice(2);
    const toast = {
      id,
      message,
      type: opts.type || "info", // 'success' | 'error' | 'info'
      timeout: typeof opts.timeout === "number" ? opts.timeout : 3000,
    };
    toasts.value.push(toast);
    if (toast.timeout > 0) setTimeout(() => remove(id), toast.timeout);
    return id;
  };
  return { toasts, show, remove };
}
